import React from 'react';
import { FormattedMessage } from '../../../util/reactIntl';
import css from './Impressum.module.css';

const ImpressumRow = ({ labelId, value, renderValue }) => {
  if (!value) {
    return null;
  }

  return (
    <p>
      <FormattedMessage id={labelId} />: {renderValue ? renderValue(value) : value}
    </p>
  );
};

/**
 * Renders the Impressum (German legal notice) details a business seller
 * filled in on their own profile - not the marketplace operator's own
 * Impressum, which lives on the static /p/impressum page instead. Reuses
 * Impressum.module.css so this matches that page's look exactly.
 */
const UserImpressum = ({ publicData }) => {
  const {
    impressum_name,
    impressum_responsible_person,
    impressum_address,
    impressum_email,
    impressum_phone_number,
    impressum_vat_id,
    impressum_registration_number,
    impressum_dispute_link,
  } = publicData || {};

  const hasAnyImpressumData = !!(
    impressum_name ||
    impressum_responsible_person ||
    impressum_address ||
    impressum_email ||
    impressum_phone_number ||
    impressum_vat_id ||
    impressum_registration_number ||
    impressum_dispute_link
  );

  if (!hasAnyImpressumData) {
    return (
      <div className={css.content}>
        <p>
          <FormattedMessage id="UserImpressum.noData" />
        </p>
      </div>
    );
  }

  return (
    <div className={css.content}>
      <ImpressumRow labelId="CustomExtendedDataField.impressum_name" value={impressum_name} />

      <ImpressumRow
        labelId="CustomExtendedDataField.impressum_responsible_person"
        value={impressum_responsible_person}
      />

      <ImpressumRow
        labelId="CustomExtendedDataField.impressum_address"
        value={impressum_address}
      />

      <ImpressumRow
        labelId="CustomExtendedDataField.impressum_email"
        value={impressum_email}
        renderValue={value => <a href={`mailto:${value}`}>{value}</a>}
      />

      <ImpressumRow
        labelId="CustomExtendedDataField.impressum_phone_number"
        value={impressum_phone_number}
        renderValue={value => <a href={`tel:${value}`}>{value}</a>}
      />

      <ImpressumRow
        labelId="CustomExtendedDataField.impressum_vat_id"
        value={impressum_vat_id}
      />

      <ImpressumRow
        labelId="CustomExtendedDataField.impressum_registration_number"
        value={impressum_registration_number}
      />

      <ImpressumRow
        labelId="CustomExtendedDataField.impressum_dispute_link"
        value={impressum_dispute_link}
        renderValue={value => (
          <a href={value} target="_blank" rel="noopener noreferrer">
            {value}
          </a>
        )}
      />
    </div>
  );
};

export default UserImpressum;
